import { ISender } from '../types/gift';

export const getSingleDeclineTitle = (company: string, sender: ISender): string => {
  const companyPart = company ? ` at ${company}` : '';
  return `This gift invitation from ${sender.fullName}${companyPart}`;
};
